<div class="container-fluid flex-column w-100"> 
<div class=" card p-4 mt-5 flex-column w-100" >
    <div [innerHTML]="'COMMON.MODIF_INFOS' | translate" (click)="backtoInfo()" class="overlay d-none">
        
    </div>
    <h5>{{'PROCESSES.HOUSING-CERTIFICATE.INFOVERIFICATION' | translate}}</h5>

    <h6 class="mt-4" [innerHTML]="'PROCESSES.HOUSING-CERTIFICATE.OFFICIAL_DOCUMENT' | translate"></h6>
    <div class="mt-4">
        <p> {{'PROFILE.FIRSTNAME' | translate}}: <span>{{currentUser.firstname}}</span></p>
        <p class="mt-1">{{'PROFILE.LASTNAME' | translate}}: <span>{{currentUser.lastname}}</span></p>
        <p class="mt-1">{{'PROFILE.BIRTHDATE' | translate}}: <span>{{currentUser.birthdate}}</span></p>
        <p class="mt-1">{{'PROFILE.BIRTHPLACE' | translate}}: <span>{{currentUser.birthplace}}</span></p>
    </div>
  
    
</div>
    <button (click)="gotoPayment()" class="btn btn-primary w-100 py-3 mt-5">{{'COMMON.CONFIRM_INFOS' | translate}}</button>
</div>



